module.exports = __webpack_public_path__ + "img/man.e9ea867f.png";